/* WordCounter — contador de palavras com alerta visual quando
 * excede o limite definido pelo Manual SFD 2026.
 */
export default function WordCounter({ text = "", max, label = "palavras" }) {
  const words = (text || "").trim().split(/\s+/).filter(Boolean).length;
  const exceeded = words > max;
  const near = !exceeded && words >= max * 0.9;
  const color = exceeded
    ? "text-rose-600 dark:text-rose-400"
    : near
      ? "text-amber-600 dark:text-amber-400"
      : "text-[var(--text-muted)]";
  return (
    <div className={`text-[11px] font-mono ${color} flex items-center gap-1.5 mt-1`} data-testid="word-counter">
      <span data-testid="word-counter-value">
        {words} / {max} {label}
      </span>
      {exceeded && (
        <span className="text-[10px] uppercase font-semibold tracking-wider bg-rose-100 dark:bg-rose-950/40 px-1.5 py-0.5 rounded" data-testid="word-counter-alert">
          Manual SFD recomenda no máximo {max} {label}.
        </span>
      )}
    </div>
  );
}
